import login from "./login.js";
import emailVerified from "./emailVerified.js";
import equipmentList from "./equipmentList.js";
import equipmentProfile from "./equipmentProfile.js";
import navigationBar from "./navigationBar.js";
import inspectionList from "./inspectionList.js";
import repairList from "./repairList.js";
import inspectionProfile from "./inspectionProfile.js";
import newArea from "./newArea.js";
import newCompany from "./newCompany.js";
import newUnit from "./newUnit.js";
import newCustomer from "./newCustomer.js";
import newHazardous from "./newHazardous.js";
import newEquipment from "./newEquipment.js";
import newSealType from "./newSealType.js";
import newConsumable from "./newConsumable.js";
import newRepairLog from "./newRepairLog.js";
import newEquipmentType from "./newEquipmentType.js";
import user from "./user.js";
import newInspection from "./newInspection.js";
import newPlant from "./newPlant.js";
import stadistics from "./stadistics.js";
import reliability from "./reliability.js";
import variables from "./variables.js";
import groups from "./groups.js";
import tour from "./tour.js";
import ticket from "./ticket.js";
import dashboard from "./dashboard.js";
import flame from "./flame.js";
import works from "./views/works";
import worksProfile from "./views/worksProfile";
import documents from "./documents.js";
import stocks from "./views/stocks";
import userProfile from "./views/userProfile";

export default {
  dashboard,
  documents,
  emailVerified,
  equipmentList,
  equipmentProfile,
  flame,
  groups,
  inspectionList,
  inspectionProfile,
  login,
  navigationBar,
  newArea,
  newCompany,
  newCustomer,
  newEquipment,
  newEquipmentType,
  newHazardous,
  newInspection,
  newPlant,
  newSealType,
  newConsumable,
  newRepairLog,
  newUnit,
  reliability,
  repairList,
  stadistics,
  stocks,
  ticket,
  tour,
  user,
  userProfile,
  variables,
  works,
  worksProfile
};
